"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useSearchResultContext = exports.defaultSearchResultContextValue = exports.SearchResultProvider = exports.Provider = void 0;
var _globalApiClientReact = require("@ori/global-api-client-react");
var _react = require("react");
var _constants = require("../constants");
var _jsxRuntime = require("react/jsx-runtime");
const defaultSearchResultContextValue = exports.defaultSearchResultContextValue = {
    loading: false,
    query: '',
    searchQuestions: [],
    totalCount: 0,
    resetSearchResults: ()=>{},
    search: ()=>{},
    showMore: ()=>{}
};
const searchResultContext = /*#__PURE__*/ (0, _react.createContext)(defaultSearchResultContextValue);
const { Provider } = searchResultContext;
exports.Provider = Provider;
const SearchResultProvider = (param)=>{
    let { children } = param;
    const apiClient = (0, _globalApiClientReact.useApiClient)();
    const [query, setQuery] = (0, _react.useState)('');
    const [skip, setSkip] = (0, _react.useState)(0);
    const [searchQuestions, setSearchQuestions] = (0, _react.useState)([]);
    const [totalCount, setTotalCount] = (0, _react.useState)(0);
    const [loading, setLoading] = (0, _react.useState)(true);
    const onSuccess = (0, _react.useCallback)((param)=>{
        let { data, status } = param;
        if (status !== 200) {
            return;
        }
        setTotalCount(data.totalCount);
        setSearchQuestions((prev)=>[
                ...prev,
                ...data.results
            ]);
    }, []);
    const fetchSearchResultsPage = (0, _react.useCallback)(async (param)=>{
        let { query: queryParam, skip: skipParam } = param;
        setLoading(true);
        await (0, _globalApiClientReact.getApplicationsSupportCenterSearch)(apiClient, {
            query: queryParam,
            skip: skipParam,
            take: _constants.MAX_AMOUNT_ITEMS_TO_RENDER
        }).then(onSuccess).finally(()=>setLoading(false));
    }, [
        apiClient,
        onSuccess
    ]);
    const search = (0, _react.useCallback)((searchQuery)=>{
        if (searchQuery === query || searchQuery.trim() === '') {
            return;
        }
        setTotalCount(0);
        setSearchQuestions([]);
        setQuery(searchQuery);
        setSkip(0);
        void fetchSearchResultsPage({
            query: searchQuery,
            skip: 0
        });
    }, [
        fetchSearchResultsPage,
        query
    ]);
    const showMore = (0, _react.useCallback)(()=>{
        if (searchQuestions.length < totalCount) {
            const newSkip = skip + _constants.MAX_AMOUNT_ITEMS_TO_RENDER;
            setSkip(newSkip);
            void fetchSearchResultsPage({
                query,
                skip: newSkip
            });
        }
    }, [
        fetchSearchResultsPage,
        query,
        searchQuestions.length,
        skip,
        totalCount
    ]);
    const resetSearchResults = (0, _react.useCallback)(()=>{
        setSkip(0);
        setQuery('');
        setSearchQuestions([]);
        setTotalCount(0);
    }, []);
    const value = (0, _react.useMemo)(()=>({
            loading,
            query,
            searchQuestions,
            totalCount,
            resetSearchResults,
            search,
            showMore
        }), [
        loading,
        query,
        resetSearchResults,
        search,
        searchQuestions,
        showMore,
        totalCount
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Provider, {
        value: value,
        children: children
    });
};
exports.SearchResultProvider = SearchResultProvider;
const useSearchResultContext = ()=>(0, _react.useContext)(searchResultContext);
exports.useSearchResultContext = useSearchResultContext;
